<div class="a-input"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional"
  [class.is-disabled]="control.disabled || isDisabled"
  [class.has-tooltip]="tooltipMessage">
  <div class="a-input__optional" *ngIf="isOptional">Optional</div>
  <i class="a-input__left-icon" *ngIf="icon" class="app-ico app-ico__{{ icon }}"></i>
  <input
    placeholder=" "
    [attr.maxlength]="maxLength"
    (input)="handleInput($event)"
    onwheel="this.blur()"
    (blur)="checkSave()"
    [type]="type"
    [formControl]="control"
    [class.has-incognito]="isAnonymous"
    [class.has-error]="control.invalid && isSubmitted"
    [class.has-search]="isSearch">
  <label>{{ label }}</label>
  <ng-container *ngIf="isSearch">
    <i class="app-ico-mask app-ico-mask__search" *ngIf="!control.value"></i>
    <i class="app-ico-mask app-ico-mask__x" *ngIf="control.value" (click)="clear()"></i>
  </ng-container>

  <ng-container *ngIf="isAnonymous">
    <i class="app-ico-mask app-ico-mask__eye-off tooltip" @opacityInOut></i>
    <div class="tooltiptext">{{ 'Common.HiddenFromRecruiter' | translate }}</div>
  </ng-container>
  
  <div class="is-tooltip" *ngIf="tooltipMessage">
    <i class="app-ico-mask app-ico-mask__info tooltip"></i>
    <div class="tooltiptext">
      {{ tooltipMessage }}
    </div>
  </div>

  <div class="a-input a-input__error-text" @opacityInOut
    *ngIf="control.invalid && isSubmitted && errorMessage">
    {{ errorMessage }}
  </div>
</div>


